import React, { useState, useEffect } from 'react';
import { decryptData, defaulUrl } from '../components/const';
import Swal from 'sweetalert2';

function ModalPubMedia({ isOpen, onClose }) {
    const [type, setType] = useState('image'); // 'image' ou 'video'
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [titre, setTitre] = useState('');
    const [description, setDescription] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;

        const fileType = selectedFile.type;
        setType(fileType.startsWith('video/') ? 'video' : 'image');
        setFile(selectedFile);
        setPreviewUrl(URL.createObjectURL(selectedFile));
    };

    const handleSubmit = () => {
        if (!titre || !description || !file) return alert('Remplissez tous les champs');
        let status = 0
        const formData = new FormData();
        formData.append('titre', titre);
        formData.append('description', description);
        formData.append('media', file);
        formData.append('type', type);
        setIsLoading(true)
        fetch(`${defaulUrl}admin-site/add-pub`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + decryptData('ACCESS_TOKEN'),
            },
            body: formData
        }).then(res => {
            status = res.status;
            setIsLoading(false)
            return res.json()
                .then(data => {
                    if ([200, 201].includes(status)) {
                        Swal.fire({ title: "Succes", text: "AJoute effectue", icon: "success" })
                        handleClose();
                    } else {

                        Swal.fire({ title: "Error", text: data.message, icon: "error" });
                    }
                }

                )
        });

    };

    const handleClose = () => {
        setTitre('');
        setDescription('');
        setFile(null);
        setPreviewUrl(null);
        setType('image');
        onClose();
    };

    useEffect(() => {
        return () => {
            if (previewUrl) URL.revokeObjectURL(previewUrl);
        };
    }, [previewUrl]);

    if (!isOpen) return null;

    return (
        <div className="modal show d-block" id='addMediaModal' tabIndex="-1" role="dialog" s
            tyle={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            {isLoading && <div className="loader"></div>}
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Ajouter un media publicitaire</h5>
                        <button type="button" className="btn-close" onClick={handleClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group mb-2">
                            <label>Titre</label>
                            <input type="text" className="form-control" value={titre} onChange={(e) => setTitre(e.target.value)} />
                        </div>

                        <div className="form-group mb-2">
                            <label>Description</label>
                            <textarea className="form-control" rows="3" value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
                        </div>


                        {previewUrl && type === 'image' && (
                            <img src={previewUrl} alt="aperçu" className="img-fluid rounded" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                        )}

                        {previewUrl && type === 'video' && (
                            <video src={previewUrl} controls className="w-100 rounded" style={{ maxHeight: '300px' }} />
                        )}

                        <div className="form-group mb-3">
                            <label>Fichier média(image ou video)</label>
                            <input type="file" accept="image/*,video/*" className="form-control" onChange={handleFileChange} />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>Annuler</button>
                        <button type="button" className="btn btn-primary" onClick={handleSubmit}>Enregistrer</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalPubMedia;
